import Repository from '@/repositories/marketing'
const sendingDomainResource = 'dkim_domains'
const linkTrackingResource = 'link_tracking_domains'
const conversionResource = 'last_touch_conversion_settings'

export default {
  fetchJwtToken(config) {
    return Repository.get(`get_jwt_key.json`, config)
  },
  fetchRelationalTableAccess(config) {
    return Repository.get(`get_relational_tables_access.json`, config)
  },
  fetchSftpAccess(config) {
    return Repository.get(`get_sftp_access.json`, config)
  },
  generateOrRegenerateToken(config) {
    return Repository.get(`generate_jwt_key.json`, config)
  },
  downloadPemFile(url, config){
    return Repository.get(`${url}`, config)
  },
  // Api Keys 
  fetchApiKeys(config) {
    return Repository.get(`api_keys.json`, config)
  },
  fetchApiKey(config) {
    return Repository.get(`api_keys.json`, config)
  },
  createNewKey(config) {
    return Repository.post(`api_keys.json`, config)
  },
  updateApiKey(id, config) {
    return Repository.patch(`api_keys/${id}.json`, config)
  },
  deleteApiKey(id) {
    return Repository.delete(`api_keys/${id}.json`)
  },
  getPermissionOptions() {
    return Repository.get(`api_keys/permission_options.json`)
  },
  updateReport (data ,config) {
    return Repository.post(`update_ftp.json`, data ,config)
  },

  //Sending Domain
  getSendingDomains(config){
    return Repository.get(`${sendingDomainResource}.json`, config)
  },
  createSendingDomains(config){
    return Repository.post(`${sendingDomainResource}.json`, config)
  },
  showSendingDomainsData(domainId){
    return Repository.get(`${sendingDomainResource}/${domainId}.json`)
  },
  verifyDkimDomain(domainId){
    return Repository.get(`${sendingDomainResource}/${domainId}/verify_dkim.json`)
  },
  verifySpfDomain(domainId){
    return Repository.get(`${sendingDomainResource}/${domainId}/verify_spf.json`)
  },
  updateDmarcValue(domainId, config){
    return Repository.put(`${sendingDomainResource}/${domainId}.json`, config)
  },
  verifyDmarcDomain(domainId){
    return Repository.get(`${sendingDomainResource}/${domainId}/verify_dmarc.json`)
  },
  deleteSendingDomain(domainId){
    return Repository.delete(`${sendingDomainResource}/${domainId}.json`)
  },
  setDefaultSendingDomain(domainId){
    return Repository.put(`${sendingDomainResource}/${domainId}/set_default.json`)
  },
  verifyYahooDomain(domainId){
    return Repository.get(`${sendingDomainResource}/${domainId}/request_yahoo_verification.json`)
  },
  verifyGoogleDomain(domainId){
    return Repository.get(`${sendingDomainResource}/${domainId}/verify_google.json`)
  },
  verifyReturnPathDomain(domainId){
    return Repository.get(`${sendingDomainResource}/${domainId}/verify_return_path.json`)
  },
  updateReturnPathSubdomain(domainId, config){
    return Repository.put(`${sendingDomainResource}/${domainId}.json`, config)
  },
  updateReturnPathToggle(domainId, config){
    return Repository.put(`${sendingDomainResource}/${domainId}.json`, config)
  },

  //Link tracking domain
  getLinkTrackingDomains(config){
    return Repository.get(`${linkTrackingResource}.json`, config)
  },
  createLinkTrackingDomains(config){
    return Repository.post(`${linkTrackingResource}.json`, config)    
  },
  showLinkTrackingDomainsData(domainId){
    return Repository.get(`${linkTrackingResource}/${domainId}.json`)
  },
  verifyCnameDomain(domainId){
    return Repository.get(`${linkTrackingResource}/${domainId}/verify_cname.json`)
  },
  deleteLinkTrackingDomain(domainId){
    return Repository.delete(`${linkTrackingResource}/${domainId}.json`)
  },
  setDefaultLinkTrackingDomain(domainId){
    return Repository.put(`${linkTrackingResource}/${domainId}/set_default.json`)
  },
  fetchDefaultLinkTrackingDomain(){
    return Repository.get(`${linkTrackingResource}/default_sms_custom_domain.json`)
  },
  setDefaultSmsLinkTrackingDomain(domainId){
    return Repository.put(`${linkTrackingResource}/${domainId}/set_default_sms_custom_domain.json`)
  },

  //smslinkTrackingdomain
  verifySmsCnameDomain(domainId){
    return Repository.get(`${linkTrackingResource}/${domainId}/verify_sms_cname.json`)
  },


  //conversionAttributes

  getDefaultConversionSettings(){
    return Repository.get(`${conversionResource}/details.json`)
  },
  getProductStatus(){
    return Repository.get(`${conversionResource}/order_statuses.json`)
  },
  disableConversionSettings(){
    return Repository.delete(`${conversionResource}/disable.json`)
  },
  updateConversionSettings(payload){
    return Repository.post(`${conversionResource}/enable.json`,payload)
  }
}